import { render, staticRenderFns } from "./TablePersonalizacao.vue?vue&type=template&id=3b816522"
import script from "./TablePersonalizacao.vue?vue&type=script&lang=js"
export * from "./TablePersonalizacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports